import { Controller } from "stimulus";
import React from "react";
import ReactDOM from "react-dom";
import CaseStudies from "~/scripts/components/CaseStudies";

export default class extends Controller {
    static targets = ["root"];

    connect() {
        const pre = this.data.get("pre");
        const applications = JSON.parse(this.data.get("applications"));
        const featured = JSON.parse(this.data.get("featured"));
        const endpoint = this.data.get("endpoint");

        const props = { pre, applications, featured, endpoint };

        ReactDOM.render(<CaseStudies {...props} />, this.rootTarget);
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/case-studies_controller.js